import { render, staticRenderFns } from "./BasicDoor.vue?vue&type=template&id=2acc7eba&scoped=true"
import script from "./BasicDoor.vue?vue&type=script&lang=js"
export * from "./BasicDoor.vue?vue&type=script&lang=js"
import style0 from "./BasicDoor.vue?vue&type=style&index=0&id=2acc7eba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acc7eba",
  null
  
)

export default component.exports